<template>
  <section class="politicas">
    <form-spinner v-if="loading" />
    <ul v-if="politicas">
      <li v-for="(item, i) in politicasFiltradas" :key="item.idNegocieJaPolitica">
        <header class="nomeCampanha">
          <h5>
            <input-control
              v-if="item.isNew"
              v-model="item.nome"
              placeholder="Nome da Política"
            />
            <span v-else>{{ item.nome }}</span>
          </h5>
          <div>
            <switch-control
              @change="toggleActivePolitica(i)"
              v-model:checked="item.ativo"
              labelOff="Inativo"
              labelOn="Ativo"
              labelPos="esq"
            />
            <span>
              <a href="#" @click.prevent="toggleActive(i)">
                <fa
                  :icon="['far','arrow-up-right-and-arrow-down-left-from-center']"
                  class="icon"
                />
              </a>
            </span>
          </div>
        </header>

        <div>
          <table>
            <thead>
              <tr>
                <th colspan="2">Período</th>
                <th colspan="2">Faixa de Valor (R$)</th>
                <th>Qtd. Dias</th>
                <th>Tipos de Bloqueio</th>
                <th>Formas de Pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="fullCell">
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.dtInicial"
                    type="date"
                    :readonly="!item.active"
                  />
                </td>
                <td class="fullCell">
                  <span class="arrowTag">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.dtFinal"
                    type="date"
                    :readonly="!item.active"
                  />
                </td>

                <td class="fullCell">
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.valorInicial"
                    ismoney
                    :readonly="!item.active"
                  />
                </td>
                <td class="fullCell">
                  <span class="arrowTag">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.valorFinal"
                    ismoney
                    :readonly="!item.active"
                  />
                </td>

                <td class="fullCell">
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.quantidadeDiasDebitosVencidos"
                    type="number"
                    :readonly="!item.active"
                  />
                </td>

                <td>
                  <div class="multiple">
                    <span>{{ item.tipoBloqueioSelecionados.length }}</span>
                    <p v-if="item.tipoBloqueioSelecionados">
                      {{ createList(item.tipoBloqueioSelecionados,'descricao') }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="multiple">
                    <span>{{ item.formasPagamento.length }}</span>
                    <p v-if="item.formasPagamento">
                      {{ createList(item.formasPagamento,'nome') }}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <template v-if="item.active">
            <div class="sub-content">
              <form-spinner v-if="item.loadingDetails" />

              <div v-else-if="item.details" class="sub-body">
                <div class="tabs-panel">
                  <nav class="tabs-navs">
                    <a
                      href="#"
                      :class="['tabs-nav', { active: item.activeTab === 'bloqueios' }]"
                      @click.prevent="toggleTab(i, 'bloqueios')"
                    >
                      <span>Tipos de Bloqueio</span>
                    </a>

                    <a
                      href="#"
                      :class="['tabs-nav', 'has-action', { active: item.activeTab === 'pagamento' }]"
                      @click.prevent="toggleTab(i, 'pagamento')"
                    >
                      <span>Formas de Pagamento</span>
                      <span class="action" @click.stop.prevent="abrirModalNovoPagamento">
                        <fa :icon="['far','plus']" />
                      </span>
                    </a>
                  </nav>

                  <div class="tabs-controller">
                    <bloqueios
                      v-show="item.activeTab === 'bloqueios'"
                      :bloqueios="item.details.tipoBloqueio"
                      @onChange="addToList('tipoBloqueio', i, $event, 'idmotivoBloqueio')"
                    />
                    <pagamento
                      v-show="item.activeTab === 'pagamento'"
                      :formasPagamento="item.details.formasPagamento"
                      @onChange="addToList('formasPagamento', i, $event, 'idNegocieJaFormaPagamento')"
                    />
                  </div>
                </div>

                <footer class="novaPolitica">
                  <a
                    href="#"
                    v-if="item.isNew"
                    class="btn btn-secondary"
                    @click.prevent="cancelarPolitica(i)"
                  >
                    Cancelar
                </a>

                  <a
                    href="#"
                    class="btn btn-primary"
                    @click.prevent="salvarPolitica(i)"
                  >
                    Salvar
                  </a>
                </footer>
              </div>
            </div>
          </template>
        </div>
      </li>
    </ul>

    <novo-pagamento
      v-if="mostrarModalNovoPagamento"
      @fechar="fecharModalNovoPagamento"
    />
  </section>
</template>

<script>
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import NegociaService from '@/services/negocieja.service.js'
import Bloqueios from '@/components/financeiro/negocieja/bloqueios/SelectBloqueios.vue'
import Pagamento from '@/components/financeiro/negocieja/pagamentos/SelectPagamento.vue'
import NovoPagamento from '@/components/financeiro/negocieja/pagamentos/NovoPagamento.vue'

export default {
  name: 'Politicas',
  components: {
    FormSpinner,
    Bloqueios,
    Pagamento,
    NovoPagamento
  },
  props: {
  busca: {
    type: String,
    default: ''
    }
  },
  data () {
    return {
      politicas: [],
      loading: false,
      mostrarModalNovoPagamento: false
    }
  },
  computed: {
  politicasFiltradas () {
    if (!this.busca.trim()) return this.politicas

    return this.politicas.filter(p =>
      p.nome.toLowerCase().includes(this.busca.toLowerCase())
    )
    }
  },
  mounted () { 
    this.getPoliticas() 
  },
  methods: {
     addToList ( type, i, value, key ) {
      this.politicas[i].selected[type] = value.map( k => k[key])
      this.politicas[i].selected[type].sort()

      console.log("this.politicas[i]:", this.politicas[i])
    },
    getPoliticas () {
      this.loading = true
      NegociaService.getPoliticas().then(
        res => {
          this.politicas = res.data.map(p => ({
            ...p,
            active: false,
            loadingDetails: false,
            activeTab: 'bloqueios',
            details: null,
            selected: {
              tipoBloqueio: [],
              formasPagamento: []
            },
            tipoBloqueio: []
          }))

          this.politicas.map(k => {
            const vf = k.valorFinal.toString()
            const vi = k.valorInicial.toString()
            k.valorInicial = vi.includes('.') ? k.valorInicial : k.valorInicial + '.00'
            k.valorFinal = vf.includes('.') ? k.valorFinal : k.valorFinal + '.00'
            console.log("k", k)
          })
        }
      ).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false
      })
    },
    getDetails (id, i) {
      this.politicas[i].loadingDetails = true
      NegociaService.getPolitica(id).then(response => {

        this.politicas[i].details = {
          tipoBloqueio: response.data.tipoBloqueio, 
          formasPagamento: response.data.formasPagamento
        }
        this.politicas[i].selected = {
          tipoBloqueio: [], 
          formasPagamento: []
        }
        
      }).catch(err => {
        console.error('Erro ao buscar detalhes da política:', err)
      }).finally(() => {
        this.politicas[i].loadingDetails = false
      })
    },
    novaPolitica () {
      const nova = {
        idNegocieJaPolitica: null,
        isNew: true,
        nome: '',
        ativo: true,
        active: true,
        loadingDetails: false,
        activeTab: 'bloqueios',
        dtInicial: '', 
        dtFinal: '',
        valorInicial: '', 
        valorFinal: '',
        quantidadeDiasDebitosVencidos: 0,
        tipoBloqueioSelecionados: [],
        selected: {
          tipoBloqueio: [],
          formasPagamento: []
        },
        formasPagamento: [],
        details: {
          tipoBloqueio: [],
          formasPagamento: []
        }
      }
      this.politicas.unshift(nova)
    },
    salvarPolitica(i) {
      const politica = this.politicas[i]
      this.loading = true
      const isNova = politica.isNew

      const payload = {
        nome: politica.nome,
        dtInicial: politica.dtInicial,
        dtFinal: politica.dtFinal,
        valorInicial: politica.valorInicial,
        valorFinal: politica.valorFinal,
        quantidadeDiasDebitosVencidos: politica.quantidadeDiasDebitosVencidos,
        ativo: politica.ativo ? 1 : 0,
        tiposBloqueio: politica.selected.tipoBloqueio,
        formasPagamento: politica.selected.formasPagamento
      };

      console.log('Payload final:', payload)

      const salvar = isNova
        ? NegociaService.createPolitica(payload)
        : NegociaService.updatePolitica(politica.idNegocieJaPolitica, payload)

      salvar.then(response => {
        const politicaSalva = response.data
        this.politicas[i] = {
          ...politica,
          ...politicaSalva,
          isNew: false,
          active: false
        };
        this.$emit('politica-salva')
        this.getPoliticas()
      }).catch(error => {
        console.error('Erro ao salvar política:', error)
      }).finally(() => {
        this.loading = false
      })
    },

    cancelarPolitica (idx) {
      this.politicas.splice(idx, 1)
      this.$emit('politica-cancelada')
    },

    toggleActive (idx) {
      const item = this.politicas[idx]
      item.active = !item.active
      if (item.active && !item.details && !item.isNew) {
        this.getDetails(item.idNegocieJaPolitica, idx)
      }
    },

    toggleTab (idx, tab) {
      this.politicas[idx].activeTab = tab
    },

    toggleActivePolitica (idx) {
      console.log(`Alterando e salvando status da política ${idx}...`);
      this.salvarPolitica(idx);
    },

    createList(arr, key) {
      return Array.isArray(arr)
        ? arr
            .filter(a => a && typeof a === 'object' && a[key] !== undefined && a[key] !== null)
            .map(a => a[key])
            .join(', ')
        : ''
    },

    abrirModalNovoPagamento () { this.mostrarModalNovoPagamento = true },
    fecharModalNovoPagamento () { this.mostrarModalNovoPagamento = false }
  }
}
</script>

<style lang="scss" scoped>

  .nomeCampanha {
    display: flex;

    .input-control{
      width: 40rem;
    }
  }
  
  .novaPolitica {
    display: flex;
    gap: 1rem;
  }

  .politicas {
    padding-bottom: $mg_large;

    ul {
      padding: $hmg_mid; margin: 0;

      li {
        list-style: none;
        padding: 0; margin: 0 0 $hmg_mid 0;
        border: $border-component;
        border-radius: $border-radius;
        background-color: $color-secondary;

        header {
          display: flex;
          align-items: center; justify-content: space-between;
          width: 100%; padding: $hmg_small $hmg_mid;

          h5, p {
            padding: 0; margin: 0;
          }
          
          >div {
            display: flex;
            align-items: center;
            gap: $mg;
            
            >span {
              display: flex;
              align-items: center;
              gap: $mg_mini;
              font-size: $font-size-large;

              .icon {
                font-size: 16px;
              }
              &:last-child {
                text-align: right;
                margin-left: $hmg_mid;
              }
              
              a {
                color: $color-primary;
              }
            }
          }
        }

        table {
          width: 100%; border-collapse: collapse;
          overflow: hidden;
          table-layout: fixed;

          thead {
            border-top: $border-component;

            tr {
              height: 50px;
              
              th {
                font-size: $font-size-small;
                padding: 0 $hmg_mid;
                text-align: center;

                &:nth-last-child( -n + 2 ) {
                  min-width: 280px; width: 20%; max-width: 360px;
                }
              }
            }
          }
          tbody {
            overflow: hidden;
            border-top: $border-component;

            tr {
              height: 50px;
              overflow: hidden;

              td {
                border: $border-component;
                padding: 0 $hmg_mid;
                position: relative;
                text-align: center;
                z-index: 8;
                
                &:first-child {
                  border-left: none !important;
                }
                &:last-child {
                  border-right: none !important;
                }

                &.over {
                  background-color: $color-debito;
                }
                &.under {
                  background-color: $color-credito;
                }

                &.fullCell {
                  padding: 0;
                }

                .arrowTag {
                  display: flex; flex-direction: column;
                  justify-content: center; align-items: center;
                  position: absolute; top: 50%; left: 0;
                  transform: translate(-50%, -50%);
                  width: 21px; height: 21px;
                  border-radius: 100%; border: $border-component;
                  font-size: 10px;
                  z-index: 12;
                  color: $color-text; background-color: $color-secondary;

                  &.over {
                    color: $color-primary;
                  }

                  &.under {
                    color: $color-success-2;
                  }
                }

                &.arrowCell {
                  >div {
                    display: flex; align-items: center; justify-content: center;
                    gap: $hmg_mini
                  }
                }

                .multiple {
                  display: flex; align-items: center;
                  gap: $mg_mini; overflow: hidden;
                  
                  span {
                    display: block;
                    width: 24px; height: 24px;
                    text-align: center; line-height: 24px;
                    flex-shrink: 0;
                    border: $border-component;
                    border-radius: 100%;
                  }
                  p {
                    margin: 0; padding: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }

              &.spinner {
                height: auto;

                td {
                  background-color: $color-secondary;
                  padding: 0 !important;
                }
              }
              &.subHeader {
                height: 40px;
                background-color: $color-bg;

                h4 {
                  margin: 0; padding: 0;
                }
              }

              &:last-child {
                td {
                  border-bottom: none !important;

                  &:last-child {
                    border-right: none !important;
                    border-bottom-right-radius: $border-radius;
                  }
                }
              }
            }
          }
        }

        .sub-content {
          width: 100%;
          border-top: $border-component;

          .sub-body {
            padding: $hmg_mid;

            footer {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-top: $hmg_mid
            }
          }
        }
      }
    }
  }
</style>